import { RootState } from 'index';

export const userToken = (state: RootState) => state.user.token;
export const userProfile = (state: RootState) => state.user.profile;
export const userStarTokenPercent = (state: RootState) => state.user.starTokenPercent;
